import {useQueryResultScreenSizes} from '../../hook/useQuery'
import {useTranslation} from '../../hook/useTranslation'
import {formatShortenNumber} from "../../utils/format";
import {useBreakpoints} from "../../hook/useBreakpoints";
import {TopList, TopListItem} from "@octavius-rocks/ui";

const TopPostsWidget = () => {

    const i18n = useTranslation("base");
    const {value = []} = useQueryResultScreenSizes();
    const clusters = useBreakpoints(value.map((item) => ({
        key: item.breakpoint,
        value: item.hits,
    })));

    if (!Array.isArray(clusters)) return null;

    return <TopList>
        {clusters.filter(({key}) => key).map(({value, key}) => {

            return <TopListItem
                key={key}
                text={key}
                description={`${formatShortenNumber(value)} ${i18n.hits}`}
            />
        })}
            </TopList>
        }

        export default TopPostsWidget
